// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `creator-terms-acceptance {
  display: block;
  width: 100%;
}
creator-terms-acceptance.modal-only {
  display: contents;
  width: auto;
}
creator-terms-acceptance .terms-agreement {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: var(--small-spacing);
  width: 100%;
  margin: var(--small-spacing) 0;
  align-items: center;
  text-align: left;
}
creator-terms-acceptance .terms-agreement .checkbox-cell {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
creator-terms-acceptance .terms-agreement p {
  cursor: pointer;
  display: block;
  margin: 0;
  text-align: left;
  line-height: 1.4;
}
creator-terms-acceptance .terms-agreement .license-checkbox {
  border: 2px solid var(--motes-black);
  border-radius: 6px;
  padding: var(--mini-spacing);
  width: 37px;
  height: 37px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: 0.2s background-color, 0.2s border-color;
}
creator-terms-acceptance .terms-agreement .license-checkbox.checked {
  background-color: var(--motes-bright-yellow);
  border-color: #ECAE2E;
}
creator-terms-acceptance .terms-agreement .license-checkbox.checked .svg-icon {
  opacity: 1;
}
creator-terms-acceptance .terms-agreement .license-checkbox .svg-icon {
  transition: 0.2s opacity;
  opacity: 0;
  font-size: 24px;
}
creator-terms-acceptance .creator-terms-modal .modal-window {
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}
creator-terms-acceptance .creator-terms-modal.full-terms .modal-window {
  min-height: min(70vh, 100vh - 48px);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
creator-terms-acceptance .creator-terms-modal.full-terms .modal-window .content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(100vh - 48px);
  overflow: hidden;
  box-sizing: border-box;
}
creator-terms-acceptance .creator-terms-modal.full-terms .modal-window .content > h3 {
  flex-shrink: 0;
}
creator-terms-acceptance .creator-terms-modal.full-terms .modal-window .content .modal-description {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  white-space: pre-wrap;
  text-align: left;
  scrollbar-width: thin;
}
creator-terms-acceptance .creator-terms-modal.full-terms .modal-window .content .select-buttons {
  flex-shrink: 0;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
creator-terms-acceptance .creator-terms-modal .terms-agreement {
  text-align: left;
}
creator-terms-acceptance .creator-terms-modal .terms-agreement p {
  text-align: left;
}
creator-terms-acceptance .creator-terms-modal .terms-agreement .license-checkbox {
  border-color: var(--motes-black);
}
creator-terms-acceptance .creator-terms-modal .modal-description {
  text-align: left;
}

publish-page creator-terms-acceptance .terms-agreement,
publish-page creator-terms-acceptance .terms-agreement p,
.creator-terms-modal .terms-agreement,
.creator-terms-modal .terms-agreement p {
  text-align: left;
}

tour-details-page creator-terms-acceptance .terms-agreement .license-checkbox,
header creator-terms-acceptance .terms-agreement .license-checkbox {
  border-color: var(--motes-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/creator-terms-acceptance/creator-terms-acceptance.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;AACJ;AAEI;EACI,iBAAA;EACA,WAAA;AAAR;AAGI;EACI,aAAA;EACA,+BAAA;EACA,gCAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAGQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AADZ;AAIQ;EACI,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,oCAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oDAAA;AAHZ;AAKY;EACI,4CAAA;EACA,qBAAA;AAHhB;AAKgB;EACI,UAAA;AAHpB;AAOY;EACI,wBAAA;EACA,UAAA;EACA,eAAA;AALhB;AAWQ;EACI,8BAAA;EACA,gBAAA;AATZ;AAYQ;EACI,mCAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAVZ;AAYY;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;AAVhB;AAYgB;EACI,cAAA;AAVpB;AAagB;EACI,cAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAXpB;AAcgB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AAZpB;AAiBQ;EACI,gBAAA;AAfZ;AAiBY;EACI,gBAAA;AAfhB;AAkBY;EACI,gCAAA;AAhBhB;AAoBQ;EACI,gBAAA;AAlBZ;;AAwBA;;;;EAII,gBAAA;AArBJ;;AAyBA;;EAEI,gCAAA;AAtBJ","sourcesContent":["creator-terms-acceptance {\n    display: block;\n    width: 100%;\n\n    // Modal-only hosts must not consume layout space in flex parents (header).\n    &.modal-only {\n        display: contents;\n        width: auto;\n    }\n\n    .terms-agreement {\n        display: grid;\n        grid-template-columns: auto 1fr;\n        column-gap: var(--small-spacing);\n        width: 100%;\n        margin: var(--small-spacing) 0;\n        align-items: center;\n        text-align: left;\n\n        .checkbox-cell {\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n        }\n\n        p {\n            cursor: pointer;\n            display: block;\n            margin: 0;\n            text-align: left;\n            line-height: 1.4;\n        }\n\n        .license-checkbox {\n            border: 2px solid var(--motes-black);\n            border-radius: 6px;\n            padding: var(--mini-spacing);\n            width: 37px;\n            height: 37px;\n            box-sizing: border-box;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            transition: 0.2s background-color, 0.2s border-color;\n\n            &.checked {\n                background-color: var(--motes-bright-yellow);\n                border-color: #ECAE2E;\n\n                .svg-icon {\n                    opacity: 1;\n                }\n            }\n\n            .svg-icon {\n                transition: 0.2s opacity;\n                opacity: 0;\n                font-size: 24px;\n            }\n        }\n    }\n\n    .creator-terms-modal {\n        .modal-window {\n            max-height: calc(100vh - 48px);\n            overflow-y: auto;\n        }\n\n        &.full-terms .modal-window {\n            min-height: min(70vh, calc(100vh - 48px));\n            max-height: calc(100vh - 48px);\n            display: flex;\n            flex-direction: column;\n            overflow: hidden;\n\n            .content {\n                display: flex;\n                flex-direction: column;\n                min-height: 0;\n                max-height: calc(100vh - 48px);\n                overflow: hidden;\n                box-sizing: border-box;\n\n                > h3 {\n                    flex-shrink: 0;\n                }\n\n                .modal-description {\n                    flex: 1 1 auto;\n                    min-height: 0;\n                    overflow-y: auto;\n                    white-space: pre-wrap;\n                    text-align: left;\n                    scrollbar-width: thin;\n                }\n\n                .select-buttons {\n                    flex-shrink: 0;\n                    margin-top: 20px;\n                    padding-top: 16px;\n                    border-top: 1px solid rgba(0, 0, 0, 0.1);\n                }\n            }\n        }\n\n        .terms-agreement {\n            text-align: left;\n\n            p {\n                text-align: left;\n            }\n\n            .license-checkbox {\n                border-color: var(--motes-black);\n            }\n        }\n\n        .modal-description {\n            text-align: left;\n        }\n    }\n}\n\n// Beat parent pages that center all <p> (e.g. publish-page ViewEncapsulation.None)\npublish-page creator-terms-acceptance .terms-agreement,\npublish-page creator-terms-acceptance .terms-agreement p,\n.creator-terms-modal .terms-agreement,\n.creator-terms-modal .terms-agreement p {\n    text-align: left;\n}\n\n// Dark surfaces (tour details + header preview dropdown)\ntour-details-page creator-terms-acceptance .terms-agreement .license-checkbox,\nheader creator-terms-acceptance .terms-agreement .license-checkbox {\n    border-color: var(--motes-white);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
